/**
 * DR-3662 — the cross-project part index. Every row is an edge the project graph draws for one reconstructed
 * document to the part node `partKey` (`part:<P/N>|<S/N>`, the graph's part node id; the S/N ignores whitespace, see
 * `foldPartNodeId`, DR-4976). Project scope is joined live through the document links and reaches every project, the
 * same reach as `GET /api/projects/:id/graph`.
 */
export const PART_LOOKUP_ROW_LIMIT = 2000;
export const PART_RECORD_EDGE_KINDS = ['mentions', 'installed-on', 'applies-to'];
/** `header`: the document's header engine lists the part. `removed-from`: an ARC's exESN, the engine the part came off. */
export const PART_RECORD_ENGINE_ROLES = ['header', 'removed-from'];
/** The graph collector that drew the edge. */
export const PART_RECORD_SOURCE_FAMILIES = ['llp', 'arc', 'qec', 'ad', 'sb', 'other'];
//# sourceMappingURL=api-parts-partkey.api.schema.js.map